import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AsOfDateService } from '../services/as-of-date.service';

/**
 * Tags every outbound API request with the user's chosen as-of-date. Backends
 * that compute "today" themselves (extraction, concierge, etc.) read this
 * header instead of `DateTime.UtcNow` when present.
 *
 * The widget render path doesn't need this header — it overrides DateOfRun
 * + AnchorDate in the body — but the interceptor catches every other endpoint
 * for free.
 */
export const asOfDateInterceptor: HttpInterceptorFn = (req, next) => {
    const asOf = inject(AsOfDateService).asOfDate();
    if (!asOf) return next(req);
    return next(req.clone({ setHeaders: { 'X-As-Of-Date': asOf } }));
};
